<div class="trip-place-card">

    <div *ngIf="item.isChoice" class="choice-label">
        <mat-icon>favorite</mat-icon>
        {{editorChoiceText}}
    </div>
    <div class="detail-operation">
        <mat-icon (click)="showOnMap($event)" matTooltip="locate on map" role="button"
            aria-label="locate on map">room</mat-icon>
    </div>

    <div class="card-picture" (click)="viewDetails($event)">
        <!--<img [src]="imageService.safeImage(imageService.imageSourceUrl(item.cover?.source||item.image))" onerror="this.src='https://imgoingcalendar.com/assets/imgs/place-holder.jpg';this.onerror=null" class="image"/>-->

        <ig-image [imageUrl]="item.cover?.source" [placeCategoryList]="item.categoryList"
            [alt]="item.title||item.name"></ig-image>

        <div class="place-card-title-wrap">
            <div class="place-card-title">
                <div class="relative">
                    <p>{{item.title||item.name}}</p>
                </div>
                <div *ngIf="icon" icon [ngStyle]="{'background-color':iconColor}">
                    <mat-icon>{{icon}}</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <div class="place-card-action-wrap">
        <div details (click)="viewDetails($event)" class="btn-div" [class.full-width]="!featuresToggle.tripPlanner"
            [style.background]="style.tripPlanner.place.color.value">see details</div>
        <ig-add-to-trip-menu add *ngIf="featuresToggle.tripPlanner" [hubName]="hubName" [item]="item"
            [addToTripText]="'add to trip'" [bgColor]="style.tripPlanner.buttons.color.value"></ig-add-to-trip-menu>
    </div>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.place.card/visitor.trip.place.card.component.html